export default __webpack_public_path__ + "static/media/Cryptocurrency.c96165ea.jpg";